// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';

const reducers = {
  setCatalogNextTraining: (state: IRootState, action: PayloadAction<IRootState['next_training']>) => ({
    ...state,
    next_training: [...state.next_training, ...action.payload.filter(
      (rep) => !state.next_training.some((r) => r.id === rep.id)
    )],
  }),
  setCatalogItems: (state: IRootState, action: PayloadAction<IRootState['items']>) => ({
    ...state,
    items: action.payload,
  }),
  setCatalogItemsCollections: (state: IRootState, action: PayloadAction<IRootState['items_collections']>) => ({
    ...state,
    items_collections: action.payload,
  }),
  removeCatalogCollectionItem: (state: IRootState, action: PayloadAction<string>) => {
    state.items_collections.items = state.items_collections.items.filter(
      (pkg) => pkg.item_id !== action.payload
    );
  },
  resetCatalogInfo: () => initialState,
};

export { reducers };
